/* ============================================================
   OBJEVO — interactions
   ============================================================ */

(function () {
  "use strict";

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  /* locale-aware calculator strings (set by the calculator section) */
  const CALC = window.OBJEVO_CALC || {};
  /* GA4 helper — analytics must never break the page */
  const track = (name, params) => {
    try {
      if (window.gtag) window.gtag("event", name, params || {});
    } catch (e) {}
  };

  /* ---------- sticky nav border ---------- */
  const nav = document.querySelector(".nav");
  const onScroll = () => nav.classList.toggle("is-scrolled", window.scrollY > 8);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- mobile nav ---------- */
  const burger = document.getElementById("navBurger");
  const links = document.getElementById("navLinks");

  burger.addEventListener("click", () => {
    const open = links.classList.toggle("is-open");
    burger.setAttribute("aria-expanded", String(open));
    burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  });

  links.addEventListener("click", (e) => {
    if (e.target.closest("a")) {
      links.classList.remove("is-open");
      burger.setAttribute("aria-expanded", "false");
    }
  });

  /* ---------- reveal on scroll ---------- */
  const revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && !prefersReducedMotion) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("in"));
  }

  /* ---------- hero before / after demo ---------- */
  const demo = document.getElementById("demo");
  const heroSwap = document.getElementById("heroSwap");
  const tabBefore = document.getElementById("tabBefore");
  const tabAfter = document.getElementById("tabAfter");
  const panelBefore = document.getElementById("panelBefore");
  const panelAfter = document.getElementById("panelAfter");

  let showingAfter = false;
  let autoCycle = null;

  const swapBefore = heroSwap.querySelector(".is-before");
  const swapAfter = heroSwap.querySelector(".is-after");

  /* size the headline swap to the active word so no gap is left */
  function sizeHeroSwap() {
    const word = showingAfter ? swapAfter : swapBefore;
    heroSwap.style.width = word.offsetWidth + "px";
  }
  window.addEventListener("resize", sizeHeroSwap);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sizeHeroSwap);
  }

  function setDemoState(after) {
    showingAfter = after;
    demo.classList.toggle("show-after", after);
    heroSwap.classList.toggle("show-after", after);
    sizeHeroSwap();

    tabBefore.classList.toggle("is-active", !after);
    tabAfter.classList.toggle("is-active", after);
    tabBefore.setAttribute("aria-selected", String(!after));
    tabAfter.setAttribute("aria-selected", String(after));

    panelBefore.classList.toggle("is-active", !after);
    panelAfter.classList.toggle("is-active", after);
    panelBefore.hidden = after;
    panelAfter.hidden = !after;
  }

  function stopAutoCycle() {
    if (autoCycle) {
      clearInterval(autoCycle);
      autoCycle = null;
    }
  }

  tabBefore.addEventListener("click", () => {
    stopAutoCycle();
    setDemoState(false);
  });

  tabAfter.addEventListener("click", () => {
    stopAutoCycle();
    setDemoState(true);
  });

  /* auto-flip until the visitor interacts */
  if (!prefersReducedMotion) {
    autoCycle = setInterval(() => setDemoState(!showingAfter), 4200);
  }

  /* ---------- lost hours calculator ---------- */
  const WEEKS_PER_MONTH = 4.33;
  const UK_WORKING_WEEK = 37.5;

  const inPeople = document.getElementById("calcPeople");
  const inHours = document.getElementById("calcHours");
  const inRate = document.getElementById("calcRate");
  const outPeople = document.getElementById("calcPeopleVal");
  const outHours = document.getElementById("calcHoursVal");
  const outRate = document.getElementById("calcRateVal");
  const resHours = document.getElementById("resHours");
  const resMonth = document.getElementById("resMonth");
  const resYear = document.getElementById("resYear");
  const resWeeks = document.getElementById("resWeeks");

  const calcRo = document.documentElement.lang === "ro";
  const calcCur = calcRo ? "€" : "£";
  const calcLoc = calcRo ? "ro-RO" : "en-GB";
  const gbp = (n) =>
    calcCur + Math.round(n).toLocaleString(calcLoc);

  // Latest computed figures, kept in sync so the email always reflects them.
  const snapshot = {};

  function paintTrack(input) {
    const min = Number(input.min);
    const max = Number(input.max);
    const pct = ((Number(input.value) - min) / (max - min)) * 100;
    input.style.setProperty("--fill", pct + "%");
  }

  function computeCalc() {
    const people = Number(inPeople.value);
    const hours = Number(inHours.value);
    const rate = Number(inRate.value);

    outPeople.textContent = String(people);
    outHours.textContent = String(hours);
    outRate.textContent = calcCur + rate;

    // Round hours first, then derive cost from the shown figure, so the
    // numbers always reproduce: shown hours × rate = shown monthly cost.
    const hoursMonth = Math.round(people * hours * WEEKS_PER_MONTH);
    const costMonth = hoursMonth * rate;
    const costYear = costMonth * 12;
    const weeksYear = Math.round((hoursMonth * 12) / UK_WORKING_WEEK);

    resHours.textContent = hoursMonth.toLocaleString(calcLoc);
    resMonth.textContent = gbp(costMonth);
    resYear.textContent = gbp(costYear);
    const weeksTail =
      weeksYear === 1
        ? CALC.weekGone || "working week a year, gone"
        : CALC.weeksGone || "working weeks a year, gone";
    resWeeks.textContent = "≈ " + weeksYear + " " + weeksTail;

    snapshot.people = people;
    snapshot.hours = hours;
    snapshot.rate = rate;
    snapshot.hoursMonth = hoursMonth.toLocaleString(calcLoc);
    snapshot.costMonth = gbp(costMonth);
    snapshot.costYear = gbp(costYear);
    snapshot.weeks = weeksYear;

    [inPeople, inHours, inRate].forEach(paintTrack);
  }

  if (inPeople && inHours && inRate && resHours) {
    let calcTracked = false;
    [inPeople, inHours, inRate].forEach((input) =>
      input.addEventListener("input", () => {
        computeCalc();
        if (!calcTracked) {
          calcTracked = true;
          track("lost_hours_result", { cta_id: "homepage_calc" });
        }
      })
    );
    computeCalc();

    const calcCta = document.querySelector(".calc__cta");
    if (calcCta) {
      calcCta.addEventListener("click", () =>
        track("lost_hours_book_click", { cta_id: "homepage_calc" })
      );
    }
  }

  /* ---------- lead capture: reveal the form, then attach the numbers to the note ---------- */
  const emailToggle = document.getElementById("emailToggle");
  const emailFields = document.getElementById("calcCaptureFields");
  if (emailToggle && emailFields) {
    emailToggle.addEventListener("click", () => {
      const open = emailFields.hidden;
      emailFields.hidden = !open;
      emailToggle.setAttribute("aria-expanded", String(open));
      if (open) {
        const inp = emailFields.querySelector('input[type="email"]');
        if (inp) inp.focus();
      }
    });
  }

  const captureForm = document.getElementById("calcCaptureHome");
  const calcNote = document.getElementById("calcNote");
  if (captureForm && calcNote) {
    captureForm.addEventListener("submit", () => {
      const s = snapshot;
      calcNote.value =
        document.documentElement.lang === "ro"
          ? "Aproximativ " + s.hoursMonth + " ore pe lună pe administrativ manual. " +
            "Cam " + s.costMonth + " pe lună, " + s.costYear + " pe an. " +
            "(Pe baza a " + s.people + " persoane, " + s.hours +
            " ore fiecare pe săptămână, la €" + s.rate + " pe oră.)"
          : "About " + s.hoursMonth + " hours a month on manual admin. " +
            "Roughly " + s.costMonth + " a month, " + s.costYear + " a year. " +
            "(Based on " + s.people + " people, " + s.hours +
            " hours each per week, at £" + s.rate + " an hour.)";
      track("lost_hours_email_click", { cta_id: "homepage_calc" });
    });
  }

  /* ---------- count-up metrics ---------- */
  const counters = document.querySelectorAll(".count");

  function animateCount(el) {
    const target = Number(el.dataset.count);
    if (prefersReducedMotion || !target) {
      el.textContent = String(target);
      return;
    }
    const duration = 1400;
    const start = performance.now();

    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  if ("IntersectionObserver" in window) {
    const countIo = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            countIo.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach((el) => countIo.observe(el));
  } else {
    counters.forEach((el) => (el.textContent = el.dataset.count));
  }

  /* ---------- FAQ: one open at a time ---------- */
  const faqItems = document.querySelectorAll(".faq__item");
  faqItems.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (item.open) {
        faqItems.forEach((other) => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ---------- booking-link analytics ---------- */
  document.querySelectorAll('a[href*="calendly.com"]').forEach((a) =>
    a.addEventListener("click", () =>
      track("lost_hours_book_click", { cta_id: a.dataset.book || "cta" })
    )
  );
})();
